<template>
    <div>
        <b-form-group
        class="input-group-var-entitat"
        label="Entitat proveïdora"
        label-size="sm"
        label-for="input-var-entitat"
        label-cols="4"
        >
            <b-form-select
            required
            size="sm"
            id="input-var-entitat"
            class="var-entitat"
            v-model="entitat"
            :options="opcionsEntitat"
            @change="onUpdateEntitat"
            >
            </b-form-select>
        </b-form-group>
    </div>
</template>

<script>
import fitxesService from "@/services/FitxesService";
export default {
    name: "VariableEntitat",
    props: {
        initialValue:{
            required: true,
        },
        ambitSeleccionat:{
            required: true,
        },
        regioSeleccionat:{
            required: true,
        }
    },
    data(){
        return {
            codiVariable: "entitat",
            ambit:"",
            regio:"",
            entitat: null,
            opcionsEntitat: [],
        };
    },
    computed: {
        returnValue(){
            let r = {codi: this.codiVariable};
            if(this.entitat != null){
                r.entitat = this.entitat
            }

            return r;
        },
    },
    methods: {
        onUpdateEntitat(value) {
            const selected = this.opcionsEntitat.find(op => op.value === value);
            this.$emit("entitat-seleccionat", selected || { value, text: "" });
        },
        recuperarValorsEntitat() {
        if (!this.ambitSeleccionat || !this.regioSeleccionat) return;
            fitxesService.getListEntitat(this.ambitSeleccionat, this.regioSeleccionat)
                .then(response => {
                // Mapeamos correctamente a las propiedades que usa b-form-select
                this.opcionsEntitat = response.data.map(entitat => ({
                    value: entitat.idEntitatProveidora,
                    text: entitat.nomEntitatProveidora
                }));

                console.table(this.opcionsEntitat); // Para verificar en consola
                })
                .catch(e => {
                console.log(e);
                });
        }

    },
    watch: {
        ambitSeleccionat() {
            this.entitat = null;
            this.recuperarValorsEntitat();
        },
        regioSeleccionat() {
            this.entitat = null;
            this.recuperarValorsEntitat();
        }
    },
    mounted(){
        if(this.initialValue != null){
            this.entitat = this.initialValue.valor;
        } else{
            this.entitat = "1";
        }
        this.recuperarValorsEntitat();
    },
    
}
</script>
<style>
.var-entitat {
  width: 250px;
}
.input-group-var-entitat .col {
  text-align: left;
}
</style>